// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.experiments.RentalManagerUserExperimentWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ExperimentGetDto, ExperimentListDto, ListingAlias } from '../..';

interface GetTreatmentParams {
  featureName: string;
  listingAlias?: ListingAlias;
}

export const RentalManagerUserExperimentWebApiHandler_getTreatment_Path = '/api/web/v1/users/experiments/getTreatment';

/**
 * Get treatment for a given feature name
 */
export const RentalManagerUserExperimentWebApiHandler_getTreatment = (
  getParams: GetTreatmentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetTreatmentParams, never, ExperimentGetDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserExperimentWebApiHandler_getTreatment_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserExperimentWebApiHandler_list_Path = '/api/web/v1/users/experiments/list';

/**
 * Get list of experiments
 */
export const RentalManagerUserExperimentWebApiHandler_list = (client = getClient()) => {
  return httpFrontEndRequest<never, never, ExperimentListDto>(
    {
      endpoint: RentalManagerUserExperimentWebApiHandler_list_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
